import type { DriveItem } from './api';

export function formatSize(bytes?: number): string {
  if (bytes === undefined) return '';
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let v = bytes / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
}

export function formatDate(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

/** A glyph for a file/folder based on MIME type. */
export function iconFor(item: Pick<DriveItem, 'mimeType' | 'isFolder'>): string {
  if (item.isFolder) return '📁';
  const m = item.mimeType;
  if (m.startsWith('image/')) return '🖼️';
  if (m === 'application/pdf') return '📄';
  if (m === 'text/html') return '🌐';
  if (m.startsWith('text/') || m === 'application/json') return '📝';
  if (m.startsWith('video/')) return '🎬';
  if (m.startsWith('audio/')) return '🎵';
  if (m === 'application/vnd.google-apps.document') return '📘';
  if (m === 'application/vnd.google-apps.spreadsheet') return '📗';
  if (m === 'application/vnd.google-apps.presentation') return '📙';
  if (m.includes('zip') || m.includes('compressed')) return '🗜️';
  return '📎';
}

export type ViewerKind = 'html' | 'pdf' | 'image' | 'markdown' | 'text' | 'google' | 'download';

export function viewerKindFor(mimeType: string, name: string): ViewerKind {
  if (mimeType === 'text/html') return 'html';
  if (mimeType === 'application/pdf') return 'pdf';
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType === 'text/markdown' || /\.mdx?$/i.test(name)) return 'markdown';
  if (mimeType.startsWith('text/') || mimeType === 'application/json') return 'text';
  if (mimeType.startsWith('application/vnd.google-apps')) return 'google';
  return 'download';
}
